import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import security from 'stores/security';
import patterns from 'utils/patterns';

const Logout: React.FC = observer(() => {
    const [searchParams] = useSearchParams();
    const nextUrl = searchParams.get('next');

    useEffect(() => {
        if (security.isLogin) {
            security.logout();
        }
    }, []);

    if (!security.isLogin) {
        window.location.href = nextUrl && patterns.isSafeUrl(nextUrl) ? nextUrl : '/';

        return null;
    }

    return <div className="text-center py-6">{__('waiting...')}</div>;
});

export default Logout;
